export type CentralReprocessamentoTipo = 'TODOS_OS_EVENTOS' | 'RUBRICAS' | 'TRABALHADORES';

export const CENTRAL_REPROCESSAMENTO_TIPO: Record<CentralReprocessamentoTipo, string> = {
  TODOS_OS_EVENTOS: 'Todos os eventos',
  RUBRICAS: 'Rubricas',
  TRABALHADORES: 'Trabalhadores',
};
